import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://lkvlvowqfoykhborgidi.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxrdmx2b3dxZm95a2hib3JnaWRpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQxODg0OTAsImV4cCI6MjA3OTc2NDQ5MH0.7aS8m5L3RtUNIsjY0T46ZU0vaCiCSfuKpajqNzjEQeg";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
